import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../../../../../shared/helpers';
import {useTheme} from '@emotion/react';

// components
import {CardBorder} from '../../../../../../shared/components';
import {Button, Divider} from '@mui/joy';
import {Link} from 'react-router-dom';

// styles
import {
  CardLoanBottom,
  CardLoanBottomLeft,
  CardLoanBottomLeftItem,
  CardLoanTop,
  CardLoanTopLeft,
  CardLoanWrapper,
} from './CardLoan-styles';

// types
import {Loan} from '../../../../../../shared/services/ApiService/types';
import {
  Subtitle,
  TextColors,
  TextDefault,
  TextExtraSmall,
  TextSmall,
  IconRightArrow,
} from '../../../../../../shared/styles';

type Props = {
  loan: Loan;
};

const CardLoan = ({loan}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <CardBorder variant="grey">
      <CardLoanWrapper>
        <CardLoanTop>
          <CardLoanTopLeft>
            <Subtitle
              bold="bold"
              color={TextColors.brand}>{`#${loan.loanNumber}`}</Subtitle>
            <TextSmall bold="bold">{loan.status}</TextSmall>
          </CardLoanTopLeft>
          <TextExtraSmall bold="bold">{loan.startDate}</TextExtraSmall>
        </CardLoanTop>
        <Divider />
        <CardLoanBottom>
          <CardLoanBottomLeft>
            <CardLoanBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('loan_loanAmount')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(loan.amount)}
              </TextDefault>
            </CardLoanBottomLeftItem>
            <CardLoanBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('global_balance')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(loan.currentBalance)}
              </TextDefault>
            </CardLoanBottomLeftItem>
          </CardLoanBottomLeft>
          <Button
            style={{
              minWidth: '104px',
              minHeight: '40px',
              borderRadius: theme.border.radius.xxs,
            }}
            variant="outlined"
            endDecorator={<IconRightArrow />}
            component={Link}
            to={`/loans/${loan.id}`}>
            {t('global_details')}
          </Button>
        </CardLoanBottom>
      </CardLoanWrapper>
    </CardBorder>
  );
};

export default CardLoan;
